export { default as ParallaxCards } from './ParallaxCards';
